yearFilter = $(".p-topicsPost__yearFilter");

if (yearFilter.length > 0) {
  let WOVNInit = false;
  yearFilter.on("change", function (e) {
    if (!WOVNInit) {
      $("article[data-year]:hidden").addClass("exclude");
      WOVNInit = true;
    }
    filterVal = $(this).val();
    $("article[data-year], .p-topicsPost__noNews").hide();
    targets =
      filterVal == "all"
        ? $("article[data-year]:not(.exclude)")
        : $("article[data-year='" + filterVal + "']:not(.exclude)");
    if (targets.length > 0) {
      targets.fadeIn();
    } else {
      selTxt = $(".p-topicsPost__yearFilter option:selected").text();
      year =
        selTxt.indexOf("過去のプレスリリース") == -1
          ? "<p>" + selTxt + "</p>" + "年"
          : "過去";
      $(".p-topicsPost__noNews")
        .html(year + "のプレスリリースは見つかりませんでした。")
        .fadeIn();
    }
  });
}
